// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import pageModule from "@insite/content-library/Pages/Page";

export const extraPageFields: FieldDefinition[] = [
    {
        name: "thumbnail",
        fieldType: "Translatable",
        editorTemplate: "ImagePickerField",
        defaultValue: "",
        isRequired: true,
    },
    {
        name: "summary",
        fieldType: "Translatable",
        editorTemplate: "MultilineTextField",
        defaultValue: "",
        isRequired: true,
    },
    {
        name: "articleType",
        displayName: "Article Type",
        fieldType: "Translatable",
        editorTemplate: "SystemListDropDownField",
        systemListName: "ArticleType",
        defaultValue: "",
    },
    {
        name: "category",
        displayName: "Category",
        fieldType: "Translatable",
        editorTemplate: "SystemListDropDownField",
        systemListName: "ResourcesCategories",
        defaultValue: "",
    },
    {
        name: "byPassAcceptTerms",
        displayName: "Hide Accept Terms Modal",
        editorTemplate: "CheckboxField",
        defaultValue: false,
        fieldType: "General",
    },
];

pageModule?.definition?.fieldDefinitions?.push(...extraPageFields);
